export default "__VITE_ASSET__DnBxuZHp__"